import { AxiosError } from 'axios';


export const errorInterceptor = (error: AxiosError) => {

  if (error.message === 'Network Error') {
    return Promise.reject(new Error('Erro de conexão.'));
  }

  // ApiLogin é usado exclusivamente para autenticar (POST /login), então um
  // 401 aqui é sempre "credenciais inválidas" e nunca "sessão expirada" —
  // não deve redirecionar/recarregar a página, apenas rejeitar para o
  // Login.tsx exibir a mensagem de erro.
  return Promise.reject(error);
};